import { ObstacleMapData } from "../ObstacleMapData";
import { ObstacleSettings } from "../ObstacleSettings";



export class RotatorObsMapData extends ObstacleMapData {
    /**
     * (RO) Otoceni kladiva pri dosazeni pozice hrace na ose Z (0 = vpravo, 90 = nahore, 180 = vlevo, 270 = dole)
     */
    get targetRotation(): number { return this._targetRot; }
    private _targetRot: number;

    /**
     * (RO) Smer rotace (-1/1)
     */
    get rotationDir(): number { return this._rotDir; }
    private _rotDir: number;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param cellId Index bunky
     * @param targetRot Otoceni kladiva pri dosazeni pozice hrace na ose Z (0 = vpravo, 90 = nahore, 180 = vlevo, 270 = dole)
     * @param rotDir Smer rotace (-1/1)
     */
    //-------------------------------------------------------------------------
    constructor(cellId: number, targetRot: number, rotDir: number, settings: ObstacleSettings) {
        super(cellId, settings);

        this._targetRot = targetRot;
        this._rotDir = rotDir;
    }
}